export enum ProjectProductType {
  COM = "COM", RES = "RES"
}
